import React from 'react'
import { ReactComponent as WestfieldLogo } from './westfield-logo.inline.svg'
import { ReactComponent as WestfieldMembershipLogo } from './westfield-membership-logo.inline.svg'
import { ReactComponent as WestfieldLogoRed } from './westfield-logo-red.inline.svg'
import cx from 'classnames'
import style from './index.scss'

export type LogoType =
  | 'default'
  | 'alt'
  | 'direct-digital'
  | 'direct-digital-mono'
  | 'direct-marketing'
  | 'direct-marketing-mono'
  | 'westfield-plus'
  | 'westfield-membership'
  | 'westfield-red'

interface LogoWithoutLinkProps {
  className?: string
  type?: LogoType

  [key: string]: unknown //...props
}

const LogoWithoutLink: React.FunctionComponent<LogoWithoutLinkProps> = ({
  className,
  type = 'default',
  ...props
}) => {
  switch (type) {
    case 'westfield-membership':
      return (
        <WestfieldMembershipLogo
          {...props}
          className={cx(className, style[type])}
        />
      )
    case 'westfield-red':
      return (
        <WestfieldLogoRed {...props} className={cx(className, style[type])} />
      )
    default:
      return <WestfieldLogo {...props} className={cx(className, style[type])} />
  }
}

export default LogoWithoutLink
